export const Types = {
  GET_REQUEST: 'privacy_policy/GET_REQUEST',
  GET_SUCCESS: 'privacy_policy/GET_SUCCESS',
};

const INITIAL_STATE = {
  privacy_policy: 'Carregando...',
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET_REQUEST:
      return { ...state, loading: true };
    case Types.GET_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return { privacy_policy: action.payload.data, loading: false, error: null };
    default:
      return state;
  }
};

export const Creators = {
  getPrivacyPolicyRequest: () => ({ type: Types.GET_REQUEST }),
  getPrivacyPolicySuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: { data },
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/privacyPolicy.js